import { SvgIcon as MuiSvgIcon, SvgIconProps as MuiSvgIconProps } from '@mui/material';

export type SvgIconProps = MuiSvgIconProps;

export const SvgIcon = MuiSvgIcon;
